import { css, jsx } from '@emotion/core';
import React from 'react';

import ContentPage from '@/src/cms/components/CMSPage/Content';
import { bp } from '@/styles';

function Covid19Resources(props) {
  return (
    <ContentPage
      {...props}
      bodyStyle={css`
        > div > ul {
          display: block;
          list-style-position: inside;
          @media ${bp.sm} {
            margin-left: 32px;
          }
          > li {
            list-style-type: disc;
          }
        }
      `}
    />
  );
}

export async function getStaticProps() {
  return { props: { sitepageid: 414 } };
}

export default Covid19Resources;
